var render = function render(){var _vm=this,_c=_vm._self._c;return _c('http-post-button',_vm._g(_vm._b({attrs:{"value":_vm.value,"href":"/api/customers","version":"v2"},on:{"http4xx":_vm.onError}},'http-post-button',_vm.$props,false),_vm.$listeners),[_c('v-icon',{attrs:{"left":""}},[_vm._v("done")]),_vm._v(_vm._s(_vm.$t('addCustomerButton.submit'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }